<form [formGroup]="form" class="form">
  <div formArrayName="websites" class="checkbox-row">
    <div class="checkbox-container">
      <label
        *ngFor="let website of websites.controls; let i = index"
        [formGroupName]="i"
        class="checkbox-item"
      >
        <input type="checkbox" formControlName="isSelected" />
        {{ website.get('name')?.value }}
      </label>
    </div>
    <div
      class="error"
      *ngIf="websites.touched && websites.errors?.atLeastOneRequired"
    >
      {{ 'text.AtLeastOneWebsite' | translate }}
    </div>
  </div>

  <div class="buttons">
    <div *ngIf="isEditMode" class="action-buttons">
      <button
        type="button"
        [disabled]="websites.errors?.atLeastOneRequired"
        (click)="save()"
      >
        {{ 'label.Save' | translate }}
      </button>
      <button type="button" (click)="cancel()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
    <div *ngIf="!isEditMode">
      <button type="button" (click)="edit()">
        {{ 'label.Edit' | translate }}
      </button>
    </div>
  </div>
</form>
